<template>
  <v-container class="mb-10">

    <v-stepper v-model="step.current" vertical class="pa-0 ma-0 pb-3">

      <!-- Patient -->
      <v-stepper-step :editable="step['1'].editable" :complete="step['1'].complete" step="1">
        {{step['1'].desc}}
        <small>{{step['1'].shortDesc}}</small>
      </v-stepper-step>
      <v-stepper-content step="1" class="pl-1">
        <patient-card v-model="form.patient"
          @input="changeStep({current: 1, to: 2})" @click="changeStep({current: 1, to: 2})" />
      </v-stepper-content>

      <!-- Professional Or Specialty -->
      <v-stepper-step step="2"
        :editable="step['2'].editable" :complete="step['2'].complete" v-if="step['2'].show">
        {{step['2'].desc}}
        <small>{{step['2'].shortDesc}}</small>
      </v-stepper-step>
      <v-stepper-content step="2" v-if="step['2'].show" class="pl-1">
        <professional-or-speciality-card v-model="form.professionalOrSpeciality"
          @click="changeStep({current: 2, to: 3})" />
      </v-stepper-content>

      <!-- Service Channel -->
      <v-stepper-step step="3"
        :editable="step['3'].editable" :complete="step['3'].complete" v-if="step['3'].show">
        {{step['3'].desc}}
        <small>{{step['3'].shortDesc}}</small>
      </v-stepper-step>
      <v-stepper-content step="3" v-if="step['3'].show" class="pl-1">
        <service-channel v-model="form.serviceChannel"
          @click="changeStep({current: 3, to: 4})" />
      </v-stepper-content>

      <!-- Payment - Particular/Covenant -->
      <v-stepper-step step="4"
        :editable="step['4'].editable" :complete="step['4'].complete" v-if="step['4'].show">
        {{step['4'].desc}}
        <small>{{step['4'].shortDesc}}</small>
      </v-stepper-step>
      <v-stepper-content step="4" v-if="step['4'].show" class="pl-1">
        <payment-card v-model="form.payment"
          :patient="form.patient" @finish="search" @click="changeStep({current: 4, to: 5})" />
      </v-stepper-content>

      <!-- Refine search -->
      <v-stepper-step step="5"
        :editable="step['5'].editable" :complete="step['5'].complete" v-if="step['5'].show">
        {{step['5'].desc}}
        <small>{{step['5'].shortDesc}}</small>
      </v-stepper-step>
      <v-stepper-content step="5" v-if="step['5'].show" class="pa-0 pr-11 ml-2">
        <refined-search-card v-model="form.refinedSearch" @finish="search" />
      </v-stepper-content>

    </v-stepper>

  </v-container>
</template>

<script>
import PatientCard from '@/components/calendars/filter/PatientCard';
import ProfessionalOrSpecialityCard from '@/components/calendars/filter/ProfessionalOrSpecialityCard';
import ServiceChannel from '@/components/calendars/filter/ServiceChannel';
import PaymentCard from '@/components/calendars/filter/PaymentCard';
import RefinedSearchCard from '@/components/calendars/filter/RefinedSearchCard';

export default {
  data: () => ({
    step: {
      current: 1,
      1: {
        desc: 'Para quem?',
        shortDesc: '',
        complete: false,
        editable: false,
        show: true,
      },
      2: {
        desc: 'Profissional ou Sintoma/Especialidade',
        shortDesc: '',
        complete: false,
        editable: false,
        show: true,
      },
      3: {
        desc: 'Forma de Atendimento',
        shortDesc: '',
        complete: false,
        editable: false,
        show: false,
      },
      4: {
        desc: 'Particular ou Convênio?',
        shortDesc: '',
        complete: false,
        editable: false,
        show: false,
      },
      5: {
        desc: 'Refinar busca',
        shortDesc: '',
        complete: false,
        editable: false,
        show: false,
      },
    },
    form: {
      patient: null,
      professionalOrSpeciality: {
        speciality: null,
        professional: null,
      },
      payment: {
        particular: false,
        covenant: null,
        priceStart: null,
        priceEnd: null,
      },
      serviceChannel: null,
      refinedSearch: {
        regress: false,
        dateStart: null,
        dateEnd: null,
        timeStart: null,
        timeEnd: null,
        weekdays: null,
        latitude: null,
        longitude: null,
        distance: null,
      },
    },
  }),
  methods: {
    changeStep(status) {
      this.step.current = status.to;
      this.step[status.current].complete = true;
      this.step[status.current].editable = true;
      if (this.step[status.to + 1]) {
        this.step[status.to + 1].show = true;
      }
    },
    search() {
      const query = {
        patient: this.form.patient,
        ...this.form.professionalOrSpeciality,
        serviceChannel: this.form.serviceChannel,
        covenant: this.form.payment.covenant,
        ...this.form.payment,
        ...this.form.refinedSearch,
      };
      const queryBase64 = btoa(JSON.stringify(query));
      this.$router.push({ name: 'calendar-search', query: { q: queryBase64 } });
    },
  },
  components: {
    PatientCard,
    ProfessionalOrSpecialityCard,
    ServiceChannel,
    PaymentCard,
    RefinedSearchCard,
  },
};
</script>
